const state = () => ({
  count: []
})

const getters = {
  count: state => {
      return state.count
  }
}

const mutations = {
  setCount (state, items) {
    state.count = items
  }
}

const actions = {
  async getCount ({ commit }) {
        commit('setCount', 0);
    // await axios
    //   .get('/api/customRequests/count')
    //   .then(resp => {
    //     commit('setCount', resp.data)
    //     // console.log(resp.data)
    //   })
    //   .catch(error => {
    //     console.log(error.response)
    //   })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
